import { ProjectPlanNew } from '../../view/pages/ProjectPlanNew'
import { Cockpit } from '../../lib/commons/appFunction'
import { intl } from '../../i18n'
import { useRegisterDemoFunctionLayer } from './useRegisterDemoFunctionLayer'
import { useDisableExternalNavigation } from './useDisableExternalNavigation'
import { useOverrideDemoGanttParameter } from './useOverrideDemoGanttParameter'
import { GanttDisplayUnit } from '../../domain/value-object/GanttParameterVO'
import { PROJECT_PLAN_MOCK_FUNCTION_UUID } from '../data/ui-states/project-plan'
import { DEMO_PLAN_START_DAY } from '../data/projects/wbs-items'
import { dayOffsetToDate } from '../data/shared'
import { DemoSupportSiteGuide } from './DemoSupportSiteGuide'

// プロジェクト計画（グリッド込み通常表示）専用モック画面。
// 本番の機能マスタ（functions）・ルーティング定義（src/view/pages/index.tsx）とは
// 独立した固定ルート（DemoRoutes.tsx）からのみ到達する。
const MOCK_FUNCTION_UUID = PROJECT_PLAN_MOCK_FUNCTION_UUID
const EXTERNAL_ID = 'mock.projectPlan'

// ガントの左端をWBSルート行の予定開始日（＝最も早い工程の開始日）に合わせる。
// 今日からの相対で決めると、WBSの先頭が画面外になったり手前が空いたりして
// ブレるため、WBSと同じ日付軸（dayOffsetToDate）から直接算出する。
// 右端も開始日からの相対。ルートの予定終了日まで伸ばすと約14ヶ月になり、
// 日単位では長すぎるので、冒頭の計画が見える範囲で切る。
const GANTT_START_DATE = dayOffsetToDate(DEMO_PLAN_START_DAY)
const GANTT_MONTHS_TO_DISPLAY = 1

// fitToRootPeriodは既定で有効だが、有効だとGanttChartParameterがWBSルートの
// 予定期間（約14ヶ月）から表示単位を自動決定し（calcAutoDisplayUnit: 62日超で
// WEEK、183日超でMONTH）、ここで指定した日単位を月単位へ上書きする。
// デモは画面ごとに単位を固定したいので無効にする。
const GANTT_DISPLAY_OPTIONS = { fitToRootPeriod: false }

export const ProjectPlan = () => {
  useRegisterDemoFunctionLayer(
    EXTERNAL_ID,
    intl.formatMessage({ id: 'demo.title.projectPlan' })
  )
  useDisableExternalNavigation()
  // 日単位で表示するためガント列の内容幅が広く、全期間が必ず画面に収まるわけ
  // ではない。列幅の最適化は製品側で常時適用されるが、日単位は内容幅の80%が
  // 下限のため、表示領域が狭いと横スクロールは残る
  // （ganttUtil.tsのGANTT_FIT_MIN_CONTENT_RATIO）。
  useOverrideDemoGanttParameter(
    GanttDisplayUnit.DAY,
    GANTT_START_DATE,
    GANTT_MONTHS_TO_DISPLAY,
    GANTT_DISPLAY_OPTIONS
  )
  return (
    <>
      <DemoSupportSiteGuide page="projectPlan" />
      <ProjectPlanNew
        key={MOCK_FUNCTION_UUID}
        externalId={EXTERNAL_ID}
        uuid={MOCK_FUNCTION_UUID}
        class={ProjectPlanNew}
        cockpit={Cockpit.Project}
        defaultPath="/projectPlan/demo"
        tags={[]}
      />
    </>
  )
}
